/**
 * Protected Route component - only allows approved users
 */

import { Navigate } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'

interface ProtectedRouteProps {
  children: React.ReactNode
}

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { user, isAuthenticated, isLoading } = useAuth()

  // Show loading state while checking auth
  if (isLoading) {
    return (
      <div className="min-h-[calc(100vh-200px)] flex items-center justify-center">
        <div className="text-gray-500">Loading...</div>
      </div>
    )
  }

  // Not authenticated - redirect to home (which shows login)
  if (!isAuthenticated) {
    return <Navigate to="/" replace />
  }

  // Authenticated but not approved - redirect to home (which shows pending/rejected page)
  if (user?.status !== 'approved') {
    return <Navigate to="/" replace />
  }

  // Approved - render children
  return <>{children}</>
}
